import React, { Fragment } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import { Formik } from 'formik';
import NumberFormat from 'react-number-format';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    colors,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Checkbox,
    TextareaAutosize
} from '@material-ui/core';

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.cyan[400],
        '&$checked': {
            color: colors.cyan[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    userlist: {
        width: '100%',
        maxHeight: 340,
        overflow: 'auto'
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));

const Action = ({ item, open, closeEdition, updateValues }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="md" fullWidth >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Ação
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                descricao: Yup.string().max(255).required('Descrição é obrigatória')
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid
                                    container
                                    spacing={2}
                                >


                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.descricao && errors.descricao)}
                                            required
                                            fullWidth
                                            rows={6}
                                            size={10}
                                            multiline="true"
                                            label="Descrição"
                                            margin="normal"
                                            name="descricao"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.descricao}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                </Grid>
                                <br></br>
                                <Divider />
                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Action;
